/**
 * EditarPartidaModal
 * Modal para editar una partida existente en el maestro
 */

import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import '../../styles/modals.css';

const EditarPartidaModal = ({ isOpen, onClose, partida, onSubmit }) => {
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [unidad, setUnidad] = useState('');
  const [cuenta, setCuenta] = useState('');
  const [status, setStatus] = useState('activo');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (partida) {
      setNombre(partida.nombre);
      setDescripcion(partida.descripcion || '');
      setUnidad(partida.unidad || '');
      setCuenta(partida.cuenta ? String(partida.cuenta) : '');
      setStatus(partida.status);
    }
  }, [partida, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nombre.trim()) {
      alert('Por favor ingresa un nombre para la partida');
      return;
    }

    setLoading(true);
    try {
      const cuentaValue = cuenta ? parseInt(cuenta) : null;
      await onSubmit({
        nombre: nombre.trim(),
        descripcion: descripcion.trim(),
        unidad: unidad.trim() || '',
        cuenta: cuentaValue,
        status
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !partida) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Editar Partida</h2>
          <button className="close-btn" onClick={onClose}>
            <FiX />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-group">
            <label htmlFor="nombre">Nombre de la Partida *</label>
            <input
              id="nombre"
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Nombre de la partida"
              maxLength={200}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="descripcion">Descripción</label>
            <textarea
              id="descripcion"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Descripción de la partida (opcional)"
              rows={3}
              disabled={loading}
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div className="form-group">
              <label htmlFor="unidad">Unidad de Medida</label>
              <input
                id="unidad"
                type="text"
                value={unidad}
                onChange={(e) => setUnidad(e.target.value)}
                placeholder="Ej: m, m², m³, kg, L"
                maxLength={50}
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="cuenta">ID de Cuenta (Opcional)</label>
              <input
                id="cuenta"
                type="number"
                value={cuenta}
                onChange={(e) => setCuenta(e.target.value)}
                placeholder="Ej: 123"
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="status">Estado</label>
            <select
              id="status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              disabled={loading}
            >
              <option value="activo">Activo</option>
              <option value="inactivo">Inactivo</option>
              <option value="archived">Archivado</option>
            </select>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Guardando...' : 'Guardar Cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditarPartidaModal;
